module.exports = __webpack_public_path__ + "media/images/img-pet-4-839b3fe7.jpg";